<template>
  <NavigationHeader :title="wp.title" />
</template>

<script>
export default {
  name: 'AboutHeader',
  inject: ['wp']
}
</script>
